import {
    CreateInsurancePolicyResult,
    CreateInsurancePolicy,
    PopulatedInsurancePolicy,
    InsuranceTypes,
} from '../../types/insurance'
import bikekeyApi, {
    INSURANCE_POLICY,
    INSURANCE_POLICY_PRE_REGISTERED,
    MY_BIKES,
    TagAbstractIds,
} from './bikekeyApi'

const insuranceEndpoints = bikekeyApi.injectEndpoints({
    endpoints: (builder) => ({
        getPolicies: builder.query<{ policies: PopulatedInsurancePolicy[] }, string>({
            query: () => ({
                url: `/insurance/policies/`,
                method: 'GET',
            }),
            providesTags: [
                { type: INSURANCE_POLICY, id: TagAbstractIds.LIST },
                { type: MY_BIKES, id: TagAbstractIds.LIST },
            ],
        }),
        getPolicy: builder.query<{ policy_data: PopulatedInsurancePolicy }, string>({
            query: (policyId: string) => ({
                url: `/insurance/policies/${policyId}/`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [
                { type: INSURANCE_POLICY, id: arg },
                { type: INSURANCE_POLICY, id: TagAbstractIds.LIST },
                { type: MY_BIKES, id: TagAbstractIds.LIST },
            ],
        }),
        getPreRegisteredPolicyStatus: builder.mutation<
            {
                insurer_policy_id: string
                policy_type_memo: InsuranceTypes
                already_exists: boolean
            },
            { insurerPartyId: string; insurerPolicyId: string; policyId?: string }
        >({
            query: ({ insurerPartyId, insurerPolicyId, policyId }) => ({
                url: `/insurance/${insurerPartyId}/policies/pre-registration-lookup/${insurerPolicyId}/`,
                method: 'POST',
                body: { policy_id: policyId },
            }),
            invalidatesTags: (result, error, arg) => [
                {
                    type: INSURANCE_POLICY_PRE_REGISTERED,
                    id: `${arg.insurerPartyId}_${arg.insurerPolicyId}`,
                },
            ],
        }),
        createPolicy: builder.mutation<CreateInsurancePolicyResult, CreateInsurancePolicy>({
            query: (body: CreateInsurancePolicy) => ({
                url: `/insurance/policies/`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: INSURANCE_POLICY, id: TagAbstractIds.LIST },
                { type: MY_BIKES, id: TagAbstractIds.LIST },
            ],
        }),
        addBikesToPolicy: builder.mutation<null, { policyId: string; numberOfBikes: number }>({
            query: ({ policyId, numberOfBikes }) => ({
                url: `/insurance/policies/${policyId}/bikes/`,
                method: 'PATCH',
                body: { number_of_bikes: numberOfBikes },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: INSURANCE_POLICY, id: arg.policyId },
                { type: MY_BIKES, id: TagAbstractIds.LIST },
                { type: MY_BIKES, id: TagAbstractIds.LIST },
            ],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetPoliciesQuery,
    useGetPolicyQuery,
    useCreatePolicyMutation,
    useAddBikesToPolicyMutation,
    useGetPreRegisteredPolicyStatusMutation,
} = insuranceEndpoints
